import { MenuItem as MMenuItem, styled } from "@mui/material";

const MenuItem = styled(MMenuItem)`
  font-size: ${({ theme }) => theme.fonts.size.default};
  font-family: ${({ theme }) => theme.fonts.family.default};
  white-space: normal;
`;

export default MenuItem;
